import React, { Component } from 'react';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';

import * as tagSelectors from '../../selectors/tagSelectors';

class SearchResults extends Component {
    render() {
        const {
            classes,
            setSearchResultsRef,
            tagsList,
            selectTag,
            selectedTags,
        } = this.props;
        
        const filteredTagsList = tagsList.filter(tag => !selectedTags.includes(tag));

        return (
            <div className={classes.searchResults} ref={setSearchResultsRef}>
                <div className={classes.tagsContainer}>
                    <div className={classes.topTagsContainer}>
                        <i className="material-icons">local_offer</i>
                        <p>Tags</p>
                    </div>
                    <div className={classes.bottomTagsContainer}>
                        {filteredTagsList.map((tag, index) => (
                            <div
                                key={index}
                                className={classes.allTags}
                                onClick={() => selectTag(tag)}
                                title={tag}
                            >
                                {tag}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }
}

const style = ({ palette }) => ({
    searchResults: {
        position: 'absolute',
        top: '38px',
        left: 0,
        right: 0,
        background: 'rgb(255, 255, 255)',
        boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 1px 1px',
        borderRadius: '4px',
        padding: '20px',
        marginTop: '10px',
        zIndex: 101,
    },
    tagsContainer: {
        display: 'flex',
        flexFlow: 'column'
    },
    bottomTagsContainer: {
        display: 'flex',
        flexFlow: 'row',
        flexWrap: 'wrap'
    },
    tagname: {
        color: palette.action.active,
    },
    topTagsContainer: {
        display: 'flex',
        alignItems: 'center',
        marginTop: '-10px',
        '& i': {
            color: palette.action.active,
            marginRight: '10px',
        },
    },
    allTags: {
        marginTop: '10px',
        cursor: 'pointer',
        borderRadius: '2px',
        background: '#f2f2f2',
        width: 'fit-content',
        padding: '1px 10px',
        marginRight: '10px',
        maxWidth: 200,
        overflow: 'hidden',
        whiteSpace: 'nowrap', 
        textOverflow: 'ellipsis'
    },
});

const mapStateToProps = state => ({
    tagsList: tagSelectors.getTagsList(state),
});

const mapDispatchToProps = () => ({
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(injectSheet(style)(SearchResults));


// WEBPACK FOOTER //
// ./src/components/search/SearchResults.js